module.exports = __webpack_public_path__ + "static/wallpaper7-cdabb5839adb2c62fcb90c42a49e287c.jpg";